import {
  Button,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useFormikContext } from "formik";
import { useState } from "react";
import InternetFrastructureList from "./InternetFrastructureList";

const InternetFrastructureView = () => {
  const { values }: any = useFormikContext();
  const [open, setOpen] = useState<boolean>();
  return (
    <Grid item md={12}>
      <Grid container spacing={3} justifyContent="center" alignItems="center">
        <Grid item md={8}>
          <Typography variant="h6">
            <strong> {values.fullAddress} </strong>
          </Typography>
        </Grid>
        {values?.internetInfrastructure?.length > 0 && (
          <Grid item md={1}>
            <IconButton color="primary" onClick={() => setOpen(!open)}>
              <InfoIcon />
            </IconButton>
            <InternetFrastructureList
              internetFrastructure={values.internetInfrastructure}
              open={open}
              setOpen={setOpen}
            />
          </Grid>
        )}
      </Grid>
      <Divider />
    </Grid>
  );
};

export default InternetFrastructureView;
